/**
 * @desc 生成供需平衡表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrder/generate/balanceSheet`, {
      method: "POST",

      ...options,
    }),
  );
}
